let scrollTop = 0

const directives = {
  /**
   * 解决当由两层元素时上下的滚动穿透问题
   */
  fixed: {
    // inserted 被绑定元素插入父节点时调用
    inserted () {
      scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      document.body.style.cssText += 'position:fixed;width:100%;'
    },
    // unbind 指令与元素解绑时调用
    unbind () {
      let body = document.body
      // let top = body.style.top
      body.style.position = ''
      document.body.scrollTop = document.documentElement.scrollTop = Number(scrollTop)
      // body.style.top = ''
    }
  },

  clickoutside: {
    inserted (el, binding) {
      el.clickCatcher = function (e) {
        if (el.contains(e.target)) {
          return false
        }

        if (binding.expression) {
          binding.value(e)
        }
      }
      window.addEventListener('click', el.clickCatcher)
    },
    unbind: (el) => window.removeEventListener('click', el.clickCatcher)
  }
}

export default directives
